(function () {
  'use strict';

  var whatsappUrl = 'https://wa.me/27632422467?text=Hi%20Smart%20Pick%20%26%20Pay%2C%20I%20need%20help%20tracking%20my%20order.';

  function heroMarkup() {
    return [
      '<section class="spp-track-hero" aria-labelledby="spp-track-title">',
      '  <div class="spp-track-decor spp-track-decor--route" aria-hidden="true">',
      '    <svg viewBox="0 0 260 220" fill="none"><path d="M-5 47c50 6 42 63 94 67 54 4 40 74 104 79"/><path d="M37 13c-3 31 22 42 47 47 31 6 49 21 45 55"/><circle cx="193" cy="193" r="8"/><path d="M193 175c-13 0-22 10-22 22 0 15 22 35 22 35s22-20 22-35c0-12-9-22-22-22Z"/></svg>',
      '  </div>',
      '  <div class="spp-track-hero__copy">',
      '    <p class="spp-track-eyebrow">Delivery updates</p>',
      '    <h1 id="spp-track-title">Track Your Order</h1>',
      '    <p>Enter your order number or tracking reference to get real-time updates on your delivery.</p>',
      '    <span class="spp-track-powered"><span class="spp-track-powered__dot" aria-hidden="true"></span>Real-time tracking powered by <strong>Bob Go</strong></span>',
      '  </div>',
      '  <div class="spp-track-decor spp-track-decor--truck" aria-hidden="true">',
      '    <svg viewBox="0 0 310 180" fill="none"><path d="M24 43h159v94H24z"/><path d="M183 75h58l42 39v23H183z"/><path d="M209 76v38h70"/><circle cx="77" cy="141" r="21"/><circle cx="234" cy="141" r="21"/><path d="M48 67h104M48 88h76"/></svg>',
      '  </div>',
      '</section>'
    ].join('');
  }

  function guideMarkup() {
    return [
      '<section class="spp-track-guide" id="spp-track-guide" aria-labelledby="spp-track-guide-title">',
      '  <div class="spp-track-guide__heading">',
      '    <div><p class="spp-track-eyebrow">From checkout to your door</p><h2 id="spp-track-guide-title">How tracking works</h2></div>',
      '    <p>Your live delivery events will appear here after you search.</p>',
      '  </div>',
      '  <div class="spp-track-guide__grid">',
      '    <div class="spp-track-journey">',
      '      <ol class="spp-track-steps" aria-label="Typical delivery journey">',
      '        <li class="is-active"><span class="spp-track-step__icon"><svg viewBox="0 0 24 24" fill="none"><path d="M5 7h14l-1.4 9H7L5 7Z"/><path d="M8 7a4 4 0 0 1 8 0M9 20h.01M16 20h.01"/></svg></span><span><strong>Order received</strong><small>We’ve received your order.</small></span></li>',
      '        <li><span class="spp-track-step__icon"><svg viewBox="0 0 24 24" fill="none"><path d="m4 8 8-4 8 4-8 4-8-4Z"/><path d="m4 8v8l8 4 8-4V8M12 12v8"/></svg></span><span><strong>Packed</strong><small>Your order is prepared for dispatch.</small></span></li>',
      '        <li><span class="spp-track-step__icon"><svg viewBox="0 0 24 24" fill="none"><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg></span><span><strong>Shipped</strong><small>Your parcel is with the courier.</small></span></li>',
      '        <li><span class="spp-track-step__icon"><svg viewBox="0 0 24 24" fill="none"><path d="M12 22s7-6 7-13a7 7 0 1 0-14 0c0 7 7 13 7 13Z"/><circle cx="12" cy="9" r="2"/></svg></span><span><strong>In transit</strong><small>Your delivery is on the way.</small></span></li>',
      '        <li><span class="spp-track-step__icon"><svg viewBox="0 0 24 24" fill="none"><path d="m5 12 4 4L19 6"/></svg></span><span><strong>Delivered</strong><small>Your order has arrived.</small></span></li>',
      '      </ol>',
      '    </div>',
      '    <div class="spp-track-preview">',
      '      <div class="spp-track-preview__top"><div><small>Tracking preview</small><h3>Your delivery details</h3></div><span>Live updates</span></div>',
      '      <dl>',
      '        <div><dt>Courier</dt><dd>Bob Go delivery partner</dd></div>',
      '        <div><dt>Tracking reference</dt><dd>Shown after search</dd></div>',
      '        <div><dt>Latest status</dt><dd>Updated in real time</dd></div>',
      '        <div><dt>Delivery progress</dt><dd>Checkpoint history</dd></div>',
      '      </dl>',
      '      <p><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg>Only tracking information connected to your reference will be displayed.</p>',
      '    </div>',
      '    <aside class="spp-track-support" aria-labelledby="spp-track-support-title">',
      '      <p class="spp-track-eyebrow">Need help?</p>',
      '      <h3 id="spp-track-support-title">We’re here for you.</h3>',
      '      <a href="' + whatsappUrl + '" target="_blank" rel="noopener"><span class="spp-track-support__icon spp-track-support__icon--wa"><svg viewBox="0 0 24 24" fill="currentColor"><path d="M17.47 14.38c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.16-.17.2-.35.22-.64.08-1.75-.88-2.9-1.57-4.06-3.56-.31-.54.31-.5.88-1.66.1-.2.05-.37-.03-.52-.07-.15-.67-1.61-.92-2.21-.24-.58-.49-.5-.67-.51-.17-.01-.37-.01-.57-.01-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.48s1.06 2.88 1.21 3.07c.15.2 2.1 3.2 5.08 4.49 1.88.81 2.62.88 3.56.74.57-.09 1.76-.72 2.01-1.41.25-.69.25-1.29.17-1.41-.07-.13-.27-.2-.57-.35zM12.05 21.79h-.01a9.87 9.87 0 0 1-5.03-1.38l-.36-.21-3.74.98 1-3.65-.24-.37a9.86 9.86 0 0 1-1.51-5.26C2.17 6.45 6.6 2.02 12.05 2.02c2.64 0 5.12 1.03 6.99 2.9a9.83 9.83 0 0 1 2.89 6.99c0 5.45-4.43 9.88-9.88 9.88z"/></svg></span><span><strong>Chat on WhatsApp</strong><small>+27 63 242 2467</small></span><b aria-hidden="true">›</b></a>',
      '      <a href="tel:+27112499599"><span class="spp-track-support__icon"><svg viewBox="0 0 24 24" fill="none"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.8 19.8 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.12.9.33 1.78.62 2.63a2 2 0 0 1-.45 2.11L8 9.73a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.85.29 1.73.5 2.63.62A2 2 0 0 1 22 16.92Z"/></svg></span><span><strong>Call our store</strong><small>011 249 9599</small></span><b aria-hidden="true">›</b></a>',
      '      <div class="spp-track-support__hours"><svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/></svg><span><strong>Support hours</strong><small>Mon–Fri: 08:30–17:30<br>Sat: 09:00–14:00</small></span></div>',
      '      <div class="spp-track-support__note"><strong>Having trouble with your order?</strong><span>Contact us with your order number and we’ll be happy to assist.</span></div>',
      '    </aside>',
      '  </div>',
      '</section>'
    ].join('');
  }

  function resultExists(container) {
    if (!container) return false;
    return Boolean(container.querySelector('.bobgo-tracking-shipment, .bobgo-card, .steps-grid, .grouped-checkpoints')) || container.textContent.trim().length > 30;
  }

  function enhance() {
    var root = document.querySelector('.bobgo-tracking');
    var search = document.getElementById('mc-search-container');
    var results = document.getElementById('mc-tracking-container');
    var input = document.getElementById('mc-tracking-number');
    var button = document.getElementById('mc-track-button');
    var heading = search && search.querySelector('h2');

    if (!root || !search || !input || !button || !heading) return false;
    if (root.dataset.sppEnhanced === 'true') return true;
    root.dataset.sppEnhanced = 'true';
    root.classList.add('spp-bobgo-ready');

    search.insertAdjacentHTML('beforebegin', heroMarkup());
    if (results) results.insertAdjacentHTML('beforebegin', guideMarkup());
    else search.insertAdjacentHTML('afterend', guideMarkup());

    var headingWrap = heading.parentElement;
    headingWrap.classList.add('spp-track-original-heading');
    heading.textContent = 'Track your order';

    input.placeholder = 'e.g. 13126 or BG123456789';
    input.setAttribute('aria-label', 'Order number or tracking reference');
    input.setAttribute('autocomplete', 'off');

    var oldSpacer = input.nextElementSibling;
    var label = document.createElement('label');
    label.className = 'spp-track-label';
    label.htmlFor = 'mc-tracking-number';
    label.textContent = 'Order number or tracking reference';

    var row = document.createElement('div');
    row.className = 'spp-track-form-row';
    input.parentNode.insertBefore(label, input);
    input.parentNode.insertBefore(row, input);
    row.appendChild(input);
    row.appendChild(button);

    if (oldSpacer && !oldSpacer.id && !oldSpacer.className && oldSpacer.textContent.trim() === '') {
      oldSpacer.remove();
    }

    button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg><span>Track Order</span>';

    var secure = document.createElement('p');
    secure.className = 'spp-track-secure';
    secure.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="10" width="16" height="11" rx="2"/><path d="M8 10V7a4 4 0 0 1 8 0v3"/></svg><span>Your information is secure and is only used to find your delivery.</span>';
    row.insertAdjacentElement('afterend', secure);

    if (results) {
      results.setAttribute('aria-live', 'polite');
      var syncResults = function () {
        root.classList.toggle('spp-track-has-results', resultExists(results));
      };
      syncResults();
      new MutationObserver(syncResults).observe(results, { childList: true, subtree: true, characterData: true });
    }

    return true;
  }

  function boot() {
    if (enhance()) return;
    var target = document.getElementById('MainContent') || document.body;
    var observer = new MutationObserver(function () {
      if (enhance()) observer.disconnect();
    });
    observer.observe(target, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
